import { render, staticRenderFns } from "./StaffRanking.vue?vue&type=template&id=0c2e68a6&"
import script from "@/scripts/administrator/staffRanking.js?vue&type=script&lang=js&"
export * from "@/scripts/administrator/staffRanking.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports